import React from 'react';
import "tabler-react/dist/Tabler.css";
import { Table, Button } from "tabler-react";
import { getAPISMaster } from "../functions/getLambdasEndpoints";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

async function getUrlPlataforma(level) {
	try {
		const endpoints = getAPISMaster().apis;
		const profile = JSON.parse(localStorage.getItem('profile'));
		let userName = profile.username;
		let url = endpoints.getUrlPlataforma.endpoint;
		const [urlPlataforma] = await Promise.all([
			axios.get(url, {
				params: {
					userName: userName,
					level: level,
				},
				headers: {
					Authorization: "",
				},
			}),
		]);
		return urlPlataforma.data;
	} catch(error) {
		return {
			error: '¡Ups! Hubo un error al validar los datos',
			url: {
				message: '¡Ups! Hubo un error al validar los datos',
			}
		}
	}
}

async function irPlataforma(level) {
	if (level !== "blackboard") {
		let url = await getUrlPlataforma(level);
		if(url.url.message || url.url.loginurl === undefined) {
			toast.warning('No se puede acceder a esta plataforma');
		} else {
			window.open(url.url.loginurl, "_blank");
		}
	} else {
		let urlBlackboard = window.location.host === "dashdocentes.ieu.edu.mx" ? "https://ieuonline.ieu.edu.mx/auth-saml/saml/login?apId=_2547_1&redirectUrl=https://ieuonline.ieu.edu.mx/ultra" : "https://testonline.ieu.edu.mx/auth-saml/saml/login?apId=_1842_1&redirectUrl=https://testonline.ieu.edu.mx/ultra";
		window.open(urlBlackboard, "_blank");
	}
}

const Blackboard = () => {
	let urlMostrar = window.location.host === "dashdocentes.ieu.edu.mx" ? "https://ieuonline.ieu.edu.mx/" : "https://testonline.ieu.edu.mx/";
	let component = <Table.Row>
	<Table.Col ><BlackBoardLogo /></Table.Col>
	<Table.Col >{urlMostrar}</Table.Col>
	<Table.Col>
		<Button className="btn-ieu" RootComponent="a" target="_blank" onClick={() => irPlataforma('blackboard')}>Ingresar</Button>
	</Table.Col>
	</Table.Row>;
	return component;
}

const BlackBoardLogo = () => (
	<svg className="bp3-icon" x="0px" y="0px" width="40" height="40" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" >
		<g>
			<path fill="#FF6F00" d="M2.5,21.5c0,0.3-0.2,0.6-0.5,0.7c0.4,0.1,0.6,0.4,0.6,0.8c0,0.6-0.5,0.9-1.2,0.9H0v-3.3h1.5C2.1,20.7,2.5,21,2.5,21.5z
				M2,21.6c0-0.3-0.2-0.4-0.6-0.4H0.6v0.9h0.8C1.7,22.1,2,21.9,2,21.6z M2.1,23c0-0.3-0.2-0.4-0.7-0.4H0.6v0.9h1
				C1.9,23.4,2.2,23.3,2.1,23L2.1,23z"/>
			<path fill="#FF6F00" d="M3.1,23.9v-3.4h0.6v3.4H3.1z"/>
			<path fill="#FF6F00" d="M5.7,23.9v-0.3C5.5,23.9,5.2,24,4.9,24C4.4,24,4,23.7,4,23.2l0,0c0-0.5,0.4-0.8,1-0.8c0.2,0,0.5,0,0.7,0.1v-0.1
				c0-0.3-0.2-0.5-0.6-0.5c-0.2,0-0.5,0.1-0.7,0.2l-0.2-0.5c0.3-0.1,0.6-0.2,0.9-0.2c0.7,0,1.1,0.4,1.1,1v1.5
				C6.2,23.9,5.7,23.9,5.7,23.9z M5.7,22.9c-0.2-0.1-0.4-0.1-0.6-0.1c-0.4,0-0.6,0.1-0.6,0.4l0,0c0,0.2,0.2,0.4,0.5,0.4
				c0.4,0,0.7-0.2,0.7-0.5V22.9z"/>
			<path fill="#FF6F00" d="M7.8,24c-0.7,0-1.3-0.5-1.3-1.2l0,0c0-0.7,0.5-1.3,1.3-1.3l0,0c0.4,0,0.7,0.1,1,0.4l-0.3,0.4C8.3,22.1,8.1,22,7.9,22
				c-0.4,0-0.7,0.4-0.7,0.8l0,0c0,0.4,0.3,0.8,0.7,0.8l0,0c0.2,0,0.5-0.1,0.6-0.3l0.3,0.3C8.6,23.8,8.2,24,7.8,24z"/>
			<path fill="#FF6F00" d="M11.4,23.9h-0.6l-0.8-1l-0.3,0.4V24H9.1v-3.4h0.6v2l1-1.1h0.7l-1,1L11.4,23.9z"/>
			<path fill="#FF6F00" d="M13.1,24c-0.3,0-0.6-0.2-0.8-0.4V24h-0.6v-3.4h0.6V22c0.2-0.3,0.5-0.5,0.8-0.5c0.6,0,1.1,0.5,1.1,1.3
				C14.3,23.5,13.7,24,13.1,24z M13,21.9c-0.4,0-0.7,0.4-0.7,0.8l0,0c0,0.4,0.3,0.8,0.7,0.8l0,0c0.4,0,0.7-0.3,0.7-0.8
				C13.7,22.2,13.4,21.9,13,21.9z"/>
			<path fill="#FF6F00" d="M15.8,24c-0.7,0-1.3-0.5-1.3-1.2l0,0c0-0.7,0.6-1.3,1.3-1.4c0.7,0,1.3,0.6,1.4,1.3C17.1,23.4,16.6,24,15.8,24L15.8,24z
				M15.8,21.9c-0.4,0-0.7,0.3-0.7,0.7l0,0c0,0.4,0.3,0.8,0.7,0.8l0,0c0.4,0,0.7-0.3,0.7-0.7l0,0C16.6,22.3,16.2,21.9,15.8,21.9
				L15.8,21.9z"/>
			<path fill="#FF6F00" d="M19,23.9v-0.3c-0.2,0.2-0.5,0.4-0.8,0.4c-0.5,0-0.9-0.3-0.9-0.8l0,0c0-0.5,0.4-0.8,1-0.8c0.2,0,0.5,0,0.7,0.1v-0.1
				c0-0.3-0.2-0.5-0.6-0.5c-0.2,0-0.5,0.1-0.7,0.2l-0.2-0.5c0.3-0.1,0.6-0.2,0.9-0.2c0.7,0,1.1,0.4,1.1,1v1.5
				C19.5,23.9,19,23.9,19,23.9z M19,22.9c-0.2-0.1-0.4-0.1-0.6-0.1c-0.4,0-0.6,0.1-0.6,0.4l0,0c0,0.2,0.2,0.4,0.5,0.4
				c0.4,0,0.7-0.2,0.7-0.5V22.9z"/>
			<path fill="#FF6F00" d="M20.5,23.9H20v-2.5h0.6V22c0.1-0.4,0.5-0.6,0.9-0.6V22l0,0c-0.5,0-0.8,0.3-0.8,1v0.9H20.5z"/>
			<path fill="#FF6F00" d="M23.4,23.9v-0.4c-0.2,0.3-0.5,0.5-0.8,0.5c-0.6,0-1.1-0.5-1.1-1.3s0.6-1.3,1.1-1.3c0.3,0,0.6,0.2,0.8,0.4v-1.3H24v3.4
				C24,23.9,23.4,23.9,23.4,23.9z M22.7,21.9c-0.4,0-0.7,0.3-0.7,0.8c0,0.4,0.3,0.8,0.7,0.8l0,0c0.4,0,0.7-0.4,0.7-0.8l0,0
				C23.5,22.3,23.2,21.9,22.7,21.9L22.7,21.9z"/>
		</g>
		<g>
			<path fill="#FF6F00" d="M20.1,0c1.1-0.1,2.3,0.8,2.5,2.2c0.1,0.8,0.2,1.6,0.3,2.4c0.1,0.7,0.2,1.5,0.3,2.2c0.1,0.8,0.2,1.6,0.3,2.4
				c0.1,0.7,0.2,1.5,0.3,2.2c0.1,0.5,0.1,0.9,0.2,1.4c0.1,1.2-0.7,2.3-1.8,2.6c-0.4,0.1-0.7,0.1-1.1,0.2c-0.7,0.1-1.4,0.2-2.1,0.3
				c-0.7,0.1-1.4,0.2-2.1,0.3c-0.7,0.1-1.4,0.2-2.1,0.3c-0.7,0.1-1.4,0.2-2.1,0.3c-0.7,0.1-1.4,0.2-2.1,0.3c-0.7,0.1-1.4,0.2-2.1,0.3
				c-0.7,0.1-1.5,0.2-2.2,0.3c-0.8,0.1-1.6,0.2-2.4,0.3C2.7,18,1.5,17,1.4,15.7c-0.1-0.8-0.2-1.6-0.3-2.4C1,12.5,0.9,11.8,0.8,11
				c-0.1-0.7-0.2-1.5-0.3-2.2C0.4,8,0.3,7.2,0.2,6.4C0.1,5.9,0.1,5.4,0,5c-0.1-1.2,0.7-2.3,1.9-2.6C2.2,2.3,2.6,2.2,3,2.2
				C3.7,2.1,4.4,2,5.1,1.9c0.7-0.1,1.4-0.2,2.1-0.3c0.7-0.1,1.4-0.2,2.1-0.3c0.7-0.1,1.4-0.2,2.1-0.3C12,1,12.7,0.9,13.4,0.8
				c0.7-0.1,1.4-0.2,2.1-0.3c0.8-0.1,1.5-0.2,2.3-0.3c0.7-0.1,1.4-0.2,2-0.3C19.9,0,20,0,20.1,0z M22.8,13c0-0.2-0.1-0.5-0.1-0.8
				c-0.1-0.7-0.2-1.4-0.3-2.1c-0.1-0.8-0.2-1.5-0.3-2.3c-0.1-0.6-0.2-1.3-0.3-1.9c-0.1-0.7-0.2-1.4-0.3-2.1c-0.1-0.5-0.1-1.1-0.2-1.6
				C21.3,1.6,20.6,1,20,1.1c-0.4,0-0.8,0.1-1.2,0.1c-0.7,0.1-1.5,0.2-2.2,0.3c-0.7,0.1-1.5,0.2-2.2,0.3c-0.9,0.1-1.7,0.2-2.6,0.3
				C11,2.3,10.2,2.4,9.5,2.5C8.7,2.6,7.9,2.7,7.1,2.8C6.3,2.9,5.6,3,4.8,3.1C4,3.2,3.2,3.3,2.4,3.4C1.7,3.5,1.1,4.1,1.2,4.9
				c0.1,0.6,0.2,1.2,0.2,1.9c0.1,1,0.2,1.9,0.4,2.9c0.1,1,0.3,2,0.4,3.1c0.1,0.9,0.2,1.9,0.4,2.8c0.1,0.7,0.8,1.2,1.4,1.2
				c0.5,0,0.9-0.1,1.3-0.2c0.8-0.1,1.6-0.2,2.4-0.3c0.7-0.1,1.5-0.2,2.2-0.3c0.7-0.1,1.5-0.2,2.2-0.3c0.7-0.1,1.5-0.2,2.2-0.3
				c0.7-0.1,1.5-0.2,2.2-0.3c0.8-0.1,1.6-0.2,2.4-0.3c0.8-0.1,1.6-0.2,2.4-0.3C22.3,14.4,22.8,13.8,22.8,13z"/>
			<path fill="#FF6F00" d="M9.3,8.8c0.3,0,0.7,0,1,0c0.3,0,0.6,0,0.8,0.1c0.6,0.2,1.1,0.6,1.4,1.2c0.2,0.5,0.3,1,0.3,1.5c-0.1,0.7-0.4,1.2-1,1.6
				c-0.6,0.5-1.4,0.8-2.2,0.9c-0.7,0.1-1.5,0.2-2.2,0.3c-0.7,0.1-1.5,0.2-2.2,0.3c-0.2,0-0.2,0-0.3-0.2c0,0,0,0,0-0.1
				c0-0.1,0-0.1,0.1-0.1c0.1,0,0.2,0,0.4,0c0.5-0.1,0.7-0.5,0.6-0.9c-0.1-0.7-0.2-1.4-0.3-2.1c-0.1-0.8-0.2-1.6-0.4-2.4
				C5.2,8,5.1,7.1,4.9,6.2C4.8,5.7,4.5,5.5,4.1,5.5c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.1,0-0.1-0.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0.1-0.1
				c0.5-0.1,1-0.1,1.6-0.2C6,4.8,6.8,4.7,7.6,4.6c0.6-0.1,1.1-0.2,1.7-0.1c0.5,0,0.9,0.1,1.3,0.4C11,5.1,11.2,5.5,11.3,6
				c0.1,0.5,0.1,1-0.2,1.4c-0.2,0.4-0.5,0.7-0.9,0.9C10,8.6,9.8,8.7,9.5,8.8C9.4,8.8,9.4,8.8,9.3,8.8z M10.9,11.5c0-0.1,0-0.2,0-0.4
				c-0.2-1-1-1.7-2.1-1.7c-0.5,0-1,0.1-1.5,0.2c-0.1,0-0.1,0-0.1,0.1c0.1,0.6,0.2,1.2,0.3,1.8c0.1,0.5,0.2,1.1,0.3,1.6
				c0.1,0.5,0.4,0.8,1,0.8c0.5,0,0.9-0.2,1.3-0.5c0.4-0.3,0.6-0.6,0.7-1.1C10.8,12,10.9,11.8,10.9,11.5z M9.6,7.2c0-0.1,0-0.3,0-0.4
				c0-0.1,0-0.2-0.1-0.3C9.3,5.6,8.7,5.2,7.8,5.2C7.4,5.2,7,5.2,6.6,5.3c-0.1,0-0.1,0-0.1,0.1C6.7,6.2,6.8,6.9,7,7.7
				C7,8.1,7.1,8.5,7.2,8.9c0,0,0,0.1,0.1,0.1C7.7,9,8.2,8.9,8.6,8.7C9,8.6,9.3,8.3,9.5,7.8C9.6,7.6,9.6,7.4,9.6,7.2z"/>
			<path fill="#FF6F00" d="M14.4,8.3c0.2-0.2,0.3-0.3,0.4-0.4c0.4-0.3,0.9-0.6,1.5-0.7c1.4-0.2,2.6,0.6,2.9,1.9c0.1,0.6,0.2,1.2,0,1.8
				c-0.2,0.7-0.7,1.2-1.3,1.6c-0.7,0.5-1.5,0.7-2.4,0.6c-0.4,0-0.8-0.1-1.2-0.2c-0.1,0-0.1,0-0.1,0c-0.1,0.1-0.3,0.3-0.4,0.4
				c0,0.1-0.1,0.1-0.2,0c-0.1,0-0.2-0.1-0.2-0.2c-0.1-1.5-0.4-2.9-0.6-4.4c-0.2-1.1-0.3-2.2-0.5-3.4c0-0.1-0.1-0.2-0.2-0.2
				c-0.2-0.1-0.4-0.1-0.6-0.2c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0.1-0.1c0.6-0.3,1.3-0.6,1.8-1.1c0.1-0.1,0.2,0,0.2,0.1
				c0.1,0.5,0.2,1,0.2,1.5c0.1,0.9,0.3,1.7,0.4,2.6C14.4,8.1,14.4,8.2,14.4,8.3z M17.8,10.8c0-0.3,0-0.6-0.1-0.8
				c-0.2-0.7-0.5-1.2-1.2-1.6c-0.2-0.1-0.4-0.2-0.7-0.2c-0.5,0-1,0.2-1.4,0.5c-0.1,0-0.1,0.1,0,0.1c0.1,1,0.3,2,0.4,3c0,0,0,0.1,0,0.1
				c0.5,0.4,1,0.6,1.6,0.5c0.6-0.1,1-0.5,1.2-1.1C17.8,11.2,17.8,11,17.8,10.8z"/>
			<path fill="#FF6F00" d="M2.2,4.6C2,4.6,2,4.6,2,4.5C2,4.4,2,4.3,2.1,4.3c0.2,0,0.5-0.1,0.7-0.1C3.6,4.1,4.3,4,5.1,3.9c0.7-0.1,1.4-0.2,2.1-0.3
				c0.7-0.1,1.5-0.2,2.2-0.3c0.7-0.1,1.5-0.2,2.2-0.3c0.8-0.1,1.5-0.2,2.3-0.3c0.7-0.1,1.4-0.2,2.1-0.3c0.7-0.1,1.4-0.2,2.1-0.3
				c0.7-0.1,1.4-0.2,2.1-0.3c0,0,0,0,0.1,0c0.1,0,0.2,0.1,0.2,0.1c0,0.1,0,0.2-0.2,0.2c-0.2,0-0.3,0-0.5,0.1c-0.7,0.1-1.4,0.2-2.1,0.3
				c-0.7,0.1-1.4,0.2-2.1,0.3c-0.7,0.1-1.4,0.2-2.1,0.3c-0.7,0.1-1.4,0.2-2.1,0.3C10.7,3.5,10,3.6,9.3,3.7C8.6,3.8,7.9,3.9,7.2,4
				C6.5,4.1,5.7,4.2,5,4.3C4.3,4.3,3.6,4.4,2.9,4.5C2.6,4.6,2.4,4.6,2.2,4.6z"/>
			<path fill="#FF6F00" d="M3.8,16.3c-0.1,0-0.2-0.1-0.2-0.1c0-0.1,0-0.2,0.2-0.2c0.4-0.1,0.8-0.1,1.2-0.2c0.8-0.1,1.5-0.2,2.3-0.3
				c0.8-0.1,1.5-0.2,2.3-0.3c0.8-0.1,1.5-0.2,2.3-0.3c0.8-0.1,1.6-0.2,2.4-0.4c0.8-0.1,1.6-0.2,2.4-0.4c0.8-0.1,1.6-0.2,2.4-0.4
				c0.8-0.1,1.6-0.2,2.4-0.4c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.2-0.1,0.2c-0.3,0-0.6,0.1-0.9,0.1
				c-0.8,0.1-1.6,0.2-2.4,0.4c-0.8,0.1-1.5,0.2-2.3,0.3c-0.8,0.1-1.6,0.2-2.4,0.4c-0.8,0.1-1.6,0.2-2.4,0.4c-0.8,0.1-1.6,0.2-2.4,0.4
				c-0.8,0.1-1.6,0.2-2.4,0.4C5.6,16,4.8,16.1,4,16.2C3.9,16.2,3.8,16.3,3.8,16.3z"/>
			<path fill="#FF6F00" d="M3,10.1c-0.1,0-0.2-0.1-0.2-0.1c0-0.1,0-0.2,0.1-0.2c0.3,0,0.5-0.1,0.8-0.1c0,0,0.1,0,0.1,0.1C3.9,10,3.9,10,3.7,10
				C3.5,10.1,3.2,10.1,3,10.1z"/>
			<path fill="#FF6F00" d="M11.2,8.5c0.3,0,0.6-0.1,0.9-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0c0,0.2,0,0.2-0.2,0.3c0,0,0,0-0.1,0
				c-0.2,0-0.4,0.1-0.6-0.1C11.5,8.6,11.4,8.6,11.2,8.5z"/>
			<path fill="#FF6F00" d="M20.2,7.7C20.1,7.7,20.1,7.7,20.2,7.7c-0.1-0.3-0.1-0.3,0.1-0.4c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2,0,0.2,0.1
				c0,0.1-0.1,0.2-0.2,0.2C20.6,7.6,20.4,7.7,20.2,7.7z"/>
			<path fill="#FF6F00" d="M5,9.5c0.1,0.1,0,0.2,0.1,0.3c0,0.1,0,0.1-0.1,0.1c-0.2,0-0.3,0-0.5,0.1c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.1-0.1
				c0-0.1-0.1-0.2,0-0.2c0-0.1,0.2,0,0.2,0C4.6,9.5,4.8,9.5,5,9.5z"/>
			<path fill="#FF6F00" d="M18.7,7.5c0.3,0,0.6-0.1,0.9-0.1c0.1,0,0.1,0,0.1,0.1c0,0.3,0,0.3-0.2,0.3c-0.1,0-0.3,0-0.4,0.1c0,0-0.1,0-0.1,0
				C18.9,7.7,18.8,7.6,18.7,7.5z"/>
		</g>
	</svg>
);

const MoodleLogo = () => (
	<svg className="bp3-icon" width="40" height="40" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" >
		<path
			fill="#FF6F00"
			d="M14.8,5.6c-0.7-0.5-1.6-0.8-2.7-0.8c-1.2,0-2.1,0.3-2.6,0.9C9.4,5.6,9.3,5.5,9.1,5.4c-0.4-0.4-1-0.9-1-0.9
			l2.5-1.9V2.5C6,3.1,3.9,3.5,0,5.8l0,0.1h0.3c0,0.3-0.1,1.1,0,2.3c-0.4,1.3,0,2.1,0.4,3.1c0.1-1,0.1-2-0.3-3.1c-0.1-1.2,0-1.9,0-2.2
			l2.6,0c0,0,0,0.7,0,1.4C3.1,7.6,3.1,7.9,3.1,8.1v5.3h2.6v-5c0-0.3,0-0.5,0.1-0.7C6.4,7.6,7.1,7.4,7.6,7c0.4,0.2,0.6,0.7,0.6,1.4v5
			h2.6v-5c0-1.1,0.4-1.6,1.3-1.6c0.9,0,1.3,0.5,1.3,1.6v5H16V8.1C16,7.1,15.6,6.2,14.8,5.6z"
		/>
	</svg>
);

function TablaPlataformas() {
	return (
		<>
			<Table className="tabla-ieu">
				<Table.Header>
					<Table.ColHeader></Table.ColHeader>
					<Table.ColHeader>Plataforma</Table.ColHeader>
					<Table.ColHeader>Ingreso</Table.ColHeader>
				</Table.Header>
				<Table.Body>
					<Table.Row>
						<Table.Col ><MoodleLogo /></Table.Col>
						<Table.Col >https://lic.ieu.edu.mx/</Table.Col>
						<Table.Col>
							<Button className="btn-ieu" RootComponent="a" target="_blank" onClick={() => irPlataforma('Licenciatura')}>Ingresar</Button>
						</Table.Col>
					</Table.Row>
					<Table.Row>
						<Table.Col ><MoodleLogo /></Table.Col>
						<Table.Col >https://mtr.ieu.edu.mx/</Table.Col>
						<Table.Col>
							<Button className="btn-ieu" RootComponent="a" target="_blank" onClick={() => irPlataforma('Maestría')}>Ingresar</Button>
						</Table.Col>
					</Table.Row>
					<Table.Row>
						<Table.Col ><MoodleLogo /></Table.Col>
						<Table.Col >https://doc.ieu.edu.mx/</Table.Col>
						<Table.Col>
							<Button className="btn-ieu" RootComponent="a" target="_blank" onClick={() => irPlataforma('Doctorado')}>Ingresar</Button>
						</Table.Col>
					</Table.Row>
					<Table.Row>
						<Table.Col ><MoodleLogo /></Table.Col>
						<Table.Col >https://econ.ieu.edu.mx/</Table.Col>
						<Table.Col>
							<Button className="btn-ieu" RootComponent="a" target="_blank" onClick={() => irPlataforma('TSU')}>Ingresar</Button>
						</Table.Col>
					</Table.Row>
					<Table.Row>
						<Table.Col ><MoodleLogo /></Table.Col>
						<Table.Col >https://onsite.ieu.edu.mx/</Table.Col>
						<Table.Col>
							<Button className="btn-ieu" RootComponent="a" target="_blank" onClick={() => irPlataforma('Onsite')}>Ingresar</Button>
						</Table.Col>
					</Table.Row>
					<Blackboard />
				</Table.Body>
			</Table>
			<ToastContainer/>
		</>
	);
}


export default TablaPlataformas;